import { loadStripe } from '@stripe/stripe-js/pure'

export default function useStripe() {
  const { $sitewideConfig } = useNuxtApp()

  const apiKey = $sitewideConfig.config.stripeKey

  async function load() {
    return await loadStripe(apiKey)
  }

  return {
    load,
  }
}
